import {createContext} from "react";

const EnvironmentContext = createContext('');

export default EnvironmentContext;